import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Slider } from "@radix-ui/themes";

type Props = {
  value: number;
  values: { label: string; value: number }[];
  min: number;
  max: number;
  step: number;
  className?: string;
  classNameSlider?: string;
  classNameLabel?: string;
  onChange: (value: number) => void;
};

export default function CreateEntitySlider({
  value,
  values,
  min,
  max,
  step,
  className,
  classNameSlider,
  classNameLabel,
  onChange,
}: Props) {
  const { t } = useTranslation("account");
  const width = 100 / (values.length - 1);

  return (
    <div className={clsx("flex flex-col w-full", className)}>
      <div className={clsx("flex items-center")}>
        {values.map((item, index) => {
          const isEdges = index === 0 || index === values.length - 1;
          return (
            <div
              key={item.value}
              className={clsx(
                "flex flex-col gap-1.5 cursor-pointer bt-1.5 text-11 font-bold text-white",
                {
                  "items-start": index === 0,
                  "items-end": index === values.length - 1,
                  "items-center": !isEdges,
                },
                classNameLabel,
              )}
              style={{
                width: isEdges ? `${width / 2}%` : `${width}%`,
              }}
            >
              {t(item.label)}
              <div className="h-[0.375rem] w-[1px] bg-white/60" />
            </div>
          );
        })}
      </div>
      <Slider
        variant="soft"
        value={[value]}
        min={min}
        max={max}
        step={step}
        onValueChange={(v: number[]) => {
          const newValue = v[0];
          onChange(newValue);
        }}
        className={clsx("cursor-pointer", classNameSlider)}
      />
    </div>
  );
}
